import { render, staticRenderFns } from "./LaptopFilters.vue?vue&type=template&id=66d28074&"
import script from "./LaptopFilters.vue?vue&type=script&lang=js&"
export * from "./LaptopFilters.vue?vue&type=script&lang=js&"
import style0 from "./LaptopFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LaptopFilters.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports